import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared';
import { ClienteBaixaCardInfoComponent } from './card-info';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteBaixaCardInfoComponent
    ],
    exports: [
        ClienteBaixaCardInfoComponent
    ]
})
export class ClienteBaixaModule { }
